// primitives/field/FieldLabel.tsx
import * as React from "react";

type Props = React.LabelHTMLAttributes<HTMLLabelElement> & {
    text?: string|React.ReactNode
}

export function FieldLabel({ text, children, ...rest }: Props) {
  return <label {...rest} data-field-label >{text}{children}</label>;
}
